module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9EHf0"))).then(() => parcelRequire('d0iPb'));